import type { RoleConfig } from '../types.js';

export const tracker: RoleConfig = {
  id: 'tracker',
  faction: 'town',
  title: { ru: 'Следопыт', uk: 'Слідопит' },
  latin: 'TRACKER',
  number: '54',
  accent: '#7ed078',
  sub: '#244818',
  ability: {
    ru: 'Ночью идёт по следу игрока — узнаёт, к кому тот ходил.',
    uk: 'Уночі йде слідами гравця — дізнається, до кого той ходив.',
  },
  abilities: [
    { key: 'track', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'town' },
};
